import { Check } from 'lucide-react';

import googleLogo from '@/assets/images/google.png';
import klaviyoLogo from '@/assets/images/klaviyo.png';
import metaLogo from '@/assets/images/meta.png';
import shopifyLogo from '@/assets/images/shopify.png';
import tiktokLogo from '@/assets/images/tiktok.png';

import { CustomerLogoGrid } from '@/features/signup/components/customer-logo-grid';
import { CUSTOMER_LOGO_GRID_SIZE } from '@/features/signup/types/customer-logo-grid-enums';

import { SignupRating } from './signup-rating';

const PLATFORM_LOGOS = [
  { src: metaLogo, alt: 'Meta' },
  { src: googleLogo, alt: 'Google' },
  { src: tiktokLogo, alt: 'TikTok' },
  { src: klaviyoLogo, alt: 'Klaviyo' },
  { src: shopifyLogo, alt: 'Shopify' },
] as const;

const FEATURES = [
  'Server-side tracking',
  'Identity resolution',
  'Multi-touch attribution',
  'Real-time analytics',
] as const;

const EYEBROW_CLASS =
  'text-xs font-medium uppercase tracking-[0.08em] text-content-secondary';

export function SocialProofPanel() {
  return (
    <div className="flex w-full max-w-lg flex-col gap-8">
      <div className="space-y-3">
        <h2 className="text-2xl font-semibold leading-8 tracking-[-0.015em] text-content-primary lg:text-3xl">
          Train your ad platforms to find more customers.
        </h2>
        <p className="type-body text-content-primary">
          Server-side tracking and identity resolution for Shopify. Every customer recognized across
          devices. Every conversion counted.
        </p>
      </div>

      <ul className="grid grid-cols-1 gap-2 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-2">
        {FEATURES.map(feature => (
          <li key={feature} className="flex items-center gap-2">
            <Check className="h-3.5 w-3.5 shrink-0 text-primary" aria-hidden="true" />
            <span className="type-body text-content-primary">{feature}</span>
          </li>
        ))}
      </ul>

      <div className="space-y-3">
        <p className={EYEBROW_CLASS}>Integrates with</p>
        <div className="flex flex-wrap items-center gap-4" aria-label="Integrates with">
          {PLATFORM_LOGOS.map(logo => (
            <img
              key={logo.alt}
              src={logo.src}
              alt={logo.alt}
              width={20}
              height={20}
              decoding="async"
              className="h-5 w-5 object-contain"
            />
          ))}
        </div>
      </div>

      <blockquote className="border-l border-border pl-4">
        <p className="type-body text-content-primary">
          &ldquo;Upstack increased our Meta ROAS by 40% in the first month.&rdquo;
        </p>
        <footer className="mt-3 flex items-center gap-3">
          <span
            className="flex size-8 shrink-0 items-center justify-center rounded-full bg-surface-inset text-xs font-medium text-content-secondary"
            aria-hidden="true"
          >
            SC
          </span>
          <div>
            <p className="type-body font-medium text-content-primary">Sarah Chen</p>
            <p className="text-xs text-content-secondary">
              Director of Marketing, Bloom Beauty
            </p>
          </div>
        </footer>
      </blockquote>

      <div className="space-y-4">
        <SignupRating />
        <CustomerLogoGrid size={CUSTOMER_LOGO_GRID_SIZE.SM} />
      </div>
    </div>
  );
}
